import { render } from "./ArticleWindow.vue?vue&type=template&id=43e66593"
import script from "./ArticleWindow.vue?vue&type=script&lang=js"
export * from "./ArticleWindow.vue?vue&type=script&lang=js"

import "./ArticleWindow.vue?vue&type=style&index=0&id=43e66593&lang=scss"
script.render = render

export default script